export default {
    id: null,
    profil: {},
    isAuthenticated: false,
    permissions: null,
};